<template lang="">
    <div class="space-bg" tabindex="0" >
        <canvas id="canvas"></canvas>
    </div>
</template>
<script>
export default {
    data() {
        return {
            canvas: null,
            gameCycle: null,
            gameOver: false,
            enemyOver: false,
            gamePause: false,
            canvasTemplate: null,
            image: null,
            now: null,
            lastTime: null,
            lastAnim: null,
            lastFireAnim: null,
            lastAction: null,
            lastController: 0,
            spaceFireTime: null,
            lastBomb: 0,
            flyerSpeed: 15,
            missileSpeed: 35,
            enemySpeed: 220,
            bombSpeed: 20,
            enemyAnimSleep: 30,
            enemyVectorRight: true,
            enemyReVector: false,
            score: 0,
            bestScore: {},
            rendering: true,
            keysDown: {
                space: false,
                right: false,
                left: false
            },
            // missileObj: [{}],
            obj: {
                flyer: [{
                    lives: 3,
                    spriteStartX: 0,
                    spriteStartY: 161,
                    spriteWidth: 105,
                    spriteHeight: 70,
                    canvasStartX: 380,
                    canvasStartY: 500,
                    canvasWidth: 75,
                    canvasHeight: 50
                }],
                enemy: [],
                missile: [],
                bomb: []
            }
        }
    },
    mounted() {
        this.image = new Image();
        this.image.src = 'img/sprites.png';
        // this.image.paintMasks(this.image);
        this.canvasTemplate = document.getElementById("canvas");
        this.canvas = this.canvasTemplate.getContext("2d");
        // this.render();
        this.canvasTemplate.width = 800;
        this.canvasTemplate.height = 600;
        this.canvas.font = "20px PressStart2P";
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
        this.generateEnemy();
        this.startGameCycle();
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
    },
    methods: {
        async generateEnemy() {
            this.gamePause = true;
            for (let i = 0; i < 11; i++) {
                for (let j = 0; j < 1; j++) {
                    await this.sleep(this.enemyAnimSleep);
                    this.obj.enemy.push(
                        {
                            bonus: 20,
                            spriteStartX: 0,
                            spriteStartY: 0,
                            spriteWidth: 42,
                            spriteHeight: 49,
                            canvasStartX: 104 + (i * 56),
                            canvasStartY: 100 + (j * 70),
                            canvasWidth: 24,
                            canvasHeight: 28
                        }
                    );
                }
                for (let j = 0; j < 1; j++) {
                    await this.sleep(this.enemyAnimSleep);
                    this.obj.enemy.push(
                        {
                            bonus: 15,
                            spriteStartX: 49,
                            spriteStartY: 49,
                            spriteWidth: 49,
                            spriteHeight: 49,
                            canvasStartX: 102 + (i * 56),
                            canvasStartY: 240 + (j * 70),
                            canvasWidth: 28,
                            canvasHeight: 28
                        }
                    );
                }
                for (let j = 0; j < 1; j++) {
                    await this.sleep(this.enemyAnimSleep);
                    this.obj.enemy.push(
                        {
                            bonus: 10,
                            spriteStartX: 0,
                            spriteStartY: 49,
                            spriteWidth: 49,
                            spriteHeight: 49,
                            canvasStartX: 102 + (i * 56),
                            canvasStartY: 170 + (j * 70),
                            canvasWidth: 28,
                            canvasHeight: 28
                        }
                    );
                }
                for (let j = 0; j < 1; j++) {
                    await this.sleep(this.enemyAnimSleep);
                    this.obj.enemy.push(
                        {
                            bonus: 5,
                            spriteStartX: 0,
                            spriteStartY: 105,
                            spriteWidth: 56,
                            spriteHeight: 56,
                            canvasStartX: 100 + (i * 56),
                            canvasStartY: 310 + (j * 70),
                            canvasWidth: 32,
                            canvasHeight: 32
                        }
                    );
                }
            }
            this.gamePause = false;
        },
        isGameOver() {
            if (this.obj.flyer[0].lives <= 0) {
                return true;
            }
            return false;
        },
        isEnemyOver() {
            if (this.obj.enemy.length === 0) {
                return true;
            }
            return false;
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        startGameCycle() {
            if (this.gameOver) {
                 this.obj.enemy = [];
                this.obj.missile = [];
                this.obj.bomb = [];
                 //////---------------------------------------отправить 
                this.getScore();
                this.gameOver = false;
                this.enemyOver = false;
               this.enemySpeed = 220;
                this.obj.flyer[0].lives = 3;
                this.score = 0;
               
                // this.generateEnemy();
            }
            else if (this.enemyOver) {
                this.enemyOver = false;
                this.obj.enemy = [];
                this.obj.missile = [];
                this.obj.bomb = [];
                // this.enemySpeed = 6;
                this.generateEnemy();
            }
            // if (!this.gamePause) {
            this.tmp();
            // }
            this.render();
            requestAnimationFrame(this.startGameCycle);
        },
        handleKeyDown() {
            switch (event.code) {
                case 'ArrowLeft':
                    if (!this.keysDown.left) {
                        this.keysDown.left = true;
                    }
                    break;
                case 'ArrowRight':
                    if (!this.keysDown.right) {
                        this.keysDown.right = true;
                    }
                    break;
                case 'Space':
                    if (!this.keysDown.space) {
                        this.keysDown.space = true;
                    }
                    break;
            }
        },
        handleKeyUp() {
            switch (event.code) {
                case 'ArrowLeft':
                    if (this.keysDown.left) {
                        this.keysDown.left = false;
                    }
                    break;
                case 'ArrowRight':
                    if (this.keysDown.right) {
                        this.keysDown.right = false;
                    }
                    break;
                case 'Space':
                    if (this.keysDown.space) {
                        this.keysDown.space = false;
                    }
                    break;
            }
        },
        keyingMotion() {
            if (this.keysDown.space) {
                this.keySpace();
            }
            if (this.keysDown.right) {
                this.keyRight();
            }
            if (this.keysDown.left) {
                this.keyLeft();
            }
        },

        keySpace() {
            if (!this.enemyOver && !this.gamePause) {
                this.now2 = Date.now();
                if (this.now2 - this.spaceFireTime >= 1000 || this.obj.missile.length === 0) {
                    this.obj.missile.push(
                        {
                            spriteStartX: 0,
                            spriteStartY: 231,
                            spriteWidth: 7,
                            spriteHeight: 28,
                            canvasStartX: this.obj.flyer[0].canvasStartX + (this.obj.flyer[0].canvasWidth / 2) - 2,
                            canvasStartY: this.obj.flyer[0].canvasStartY,
                            canvasWidth: 5,
                            canvasHeight: 20
                        }
                    );
                    this.spaceFireTime = this.now2
                }
            } else {
                this.rendering = true;
            }
        },
        keyLeft() {
            if (this.obj.flyer[0].canvasStartX > this.flyerSpeed) {
                this.obj.flyer[0].canvasStartX -= this.flyerSpeed;
            }
            // this.render();
        },
        keyRight() {
            if (this.obj.flyer[0].canvasStartX < 800 - (this.obj.flyer[0].canvasWidth + this.flyerSpeed)) {
                this.obj.flyer[0].canvasStartX += this.flyerSpeed;
            }
            // this.render();
        },
        tmp() {
            this.now = Date.now();
            this.lastAnim += this.now - this.lastTime;
            this.lastAction += this.now - this.lastTime;
            this.lastController += this.now - this.lastTime;
            this.lastBomb += this.now - this.lastTime;
            this.lastFireAnim += this.now - this.lastTime;
            if (this.lastFireAnim >= 50) {
                for (let i = 0; i < this.obj.missile.length; i++) {
                    this.anim(this.obj.missile[i]);
                }
                for (let i = 0; i < this.obj.bomb.length; i++) {
                    this.anim(this.obj.bomb[i]);
                }
                this.lastFireAnim = 0;
            }
            if (this.lastBomb >= 5000 && this.obj.enemy.length > 0) {
                let enemyAttack = Math.floor(Math.random() * (this.obj.enemy.length - 1))
                // console.log(this.obj.enemy.length);
                this.obj.bomb.push(
                    {
                        spriteStartX: 0,
                        spriteStartY: 259,
                        spriteWidth: 21,
                        spriteHeight: 49,
                        canvasStartX: this.obj.enemy[enemyAttack].canvasStartX + (this.obj.enemy[enemyAttack].canvasWidth / 2) - 2,
                        canvasStartY: this.obj.enemy[enemyAttack].canvasStartY + this.obj.enemy[enemyAttack].canvasHeight,
                        canvasWidth: 9,
                        canvasHeight: 21
                    }
                );
                this.lastBomb = 0;
            }
            if (this.lastController >= 20) {
                this.keyingMotion();
                this.lastController = 0;
            }
            if (this.lastAction >= 50) {
                for (let i = 0; i < this.obj.bomb.length; i++) {
                    if (this.obj.bomb[i].canvasStartY < 600) {
                        if (this.checkRectangle(this.obj.bomb[i], this.obj.flyer[0])) {
                            this.obj.flyer[0].lives--;
                            this.gameOver = this.isGameOver();
                            this.enemyOver = true;
                            return;
                        }
                        this.obj.bomb[i].canvasStartY = this.obj.bomb[i].canvasStartY + this.bombSpeed;
                    } else {
                        this.obj.bomb.splice(i, 1);

                    }
                }
                for (let i = 0; i < this.obj.missile.length; i++) {
                    // if (this.obj[i].type === 'missile') {
                    if (this.obj.missile[i].canvasStartY > 0) {
                        for (let j = 0; j < this.obj.enemy.length; j++) {
                            if (this.checkRectangle(this.obj.missile[i], this.obj.enemy[j])) {
                                this.score += this.obj.enemy[j].bonus;
                                this.obj.missile.splice(i, 1);
                                this.obj.enemy.splice(j, 1);
                                this.enemyOver = this.isEnemyOver();
                                // this.gameOver = this.isGameOver();
                                return;
                            }
                            // }
                        }
                        this.obj.missile[i].canvasStartY = this.obj.missile[i].canvasStartY - this.missileSpeed;
                        // if (!this.dangerExplosion(this.obj.missile[i], this.obj.enemy)) {
                        //     this.obj.missile[i].canvasStartY = this.obj.missile[i].canvasStartY - this.missileSpeed;
                        // } else {
                        //     this.gameOver = this.isGameOver();
                        //     return;
                        // }
                    } else {
                        this.obj.missile.splice(i, 1);

                    }
                    // } else if (this.obj[i].type.slice(0, -1) === 'enemy') {
                    //     break;
                    // }
                }
                this.lastAction = 0;
            }
            if (!this.gamePause) {
                if (this.lastAnim >= Math.round(22 * this.obj.enemy.length)) {
                    this.anim(this.obj.flyer[0]);
                    if (this.enemyReVector) {
                        this.enemyVectorRight = !this.enemyVectorRight;
                        this.enemyReVector = false;
                        // this.enemySpeed++;
                        for (let i = 0; i < this.obj.enemy.length; i++) {
                            // if (this.obj[i].type.slice(0, -1) === 'enemy') {
                            this.obj.enemy[i].canvasStartY += Math.round(this.enemySpeed / this.obj.enemy.length);
                            if (this.obj.enemy[i].canvasStartY > 451) {
                                this.obj.flyer[0].lives--;
                                this.gameOver = this.isGameOver();
                                this.enemyOver = true;
                                return;
                            }
                            // } else {
                            //     break;
                            // }
                        }
                    } else {
                        for (let i = 0; i < this.obj.enemy.length; i++) {
                            this.anim(this.obj.enemy[i]);
                            // if (this.obj.enemy[i].spriteStartX === 0) {
                            //     this.obj.enemy[i].spriteStartX = this.obj.enemy[i].spriteWidth;
                            // } else {
                            //     this.obj.enemy[i].spriteStartX = 0;
                            // }
                            // if (this.obj[i].type.slice(0, -1) === 'enemy') {
                            if (this.enemyVectorRight) {
                                this.obj.enemy[i].canvasStartX += Math.round(this.enemySpeed / this.obj.enemy.length);
                                if (this.obj.enemy[i].canvasStartX > 730) {
                                    // this.obj.enemy[i].canvasStartX = 730;
                                    this.enemyReVector = true;
                                }
                            }
                            else {
                                this.obj.enemy[i].canvasStartX -= Math.round(this.enemySpeed / this.obj.enemy.length);
                                if (this.obj.enemy[i].canvasStartX < 40) {
                                    // this.obj.enemy[i].canvasStartX = 40;
                                    this.enemyReVector = true;
                                }
                            }
                            // }
                        }
                    }
                    this.lastAnim = 0;
                }
            }
            this.lastTime = this.now;
        },
        // dangerExplosion(missile, enemy) {
        //     for (let i = 1; i < enemy.length; i++) {
        //         // if (this.obj[i].type.slice(0, -1) === 'enemy') {
        //         if (this.checkRectangle(missile, enemy[i])) {
        //             delete missile;
        //             // this.obj.splice(missile, 1);
        //             // this.obj.splice(i, 1);
        //             return i;
        //         }
        //         // }
        //     }
        //     return false;
        // },
        anim(obj) {
            if (obj.spriteStartX === 0) {
                obj.spriteStartX = obj.spriteWidth;
            } else {
                obj.spriteStartX = 0;
            }
        },
        checkRectangle(missile, enemy) {
            // maxAx < minBx;
            // minAx > maxBx;
            // minAy > maxBy;
            // maxAy < minBy;
            return !(
                (missile.canvasStartX + missile.canvasWidth) < enemy.canvasStartX ||
                missile.canvasStartX > (enemy.canvasStartX + enemy.canvasWidth) ||
                missile.canvasStartY > (enemy.canvasStartY + enemy.canvasHeight) ||
                (missile.canvasStartY + missile.canvasHeight) < enemy.canvasStartY
            );
        },
        render() {
            if (this.rendering) {
                this.canvas.clearRect(0, 0, 800, 600);
                Object.values(this.obj).forEach(value => {
                    value.forEach(items => {
                        this.canvas.drawImage(
                            this.image,
                            items.spriteStartX,
                            items.spriteStartY,
                            items.spriteWidth,
                            items.spriteHeight,
                            items.canvasStartX,
                            items.canvasStartY,
                            items.canvasWidth,
                            items.canvasHeight
                        );
                    });
                });
                this.renderText("СЧЕТ: " + this.score, "#edd5b2", 20, 20);
            }
            // this.canvas.fillStyle = "#edd5b2";
            // this.canvas.textBaseline = 'top';
            // this.canvas.fillText("СЧЕТ: " + this.score, 20, 20);
        },
        renderText(text, color, x, y) {
            this.canvas.fillStyle = color;
            this.canvas.textBaseline = 'top';
            this.canvas.fillText(text, x, y);
        },
        getScore() {
            this.axios
                .get(this.$store.getters.URL + '/api/spacescore')
                .then(response => (this.bestScore = response.data.score,
                    this.viewBestScore()
                ));
        },
        viewBestScore() {
            this.rendering = false;
            this.enemyOver = true; 
            this.gamePause = true;
            let i = 1;
            this.bestScore.forEach(element => {
                this.renderText(element.name + ' ------ ' + element.score, "#aaaaaa", 200, 120 + (30 * i++));
            });
        }
    }
}
</script>
<style>
@font-face {
    font-family: 'PressStart2P';
    src: url('~@/assets/fonts/PressStart2P-Regular.woff2') format('woff2'),
        url('~@/assets/fonts/PressStart2P-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

.space-bg {
    background-color: rgb(68, 70, 72);
    width: 100vw;
    height: 100vh;
}

#canvas {
    font-family: 'PressStart2P';
    background-color: black;
    width: 800px;
    height: 600px;
    position: relative;
    top: calc(50vh - 300px);
}
</style>